import { render } from "./OapPageNavigationForColorsonic.vue?vue&type=template&id=945c2402"
import script from "./OapPageNavigationForColorsonic.vue?vue&type=script&lang=js"
export * from "./OapPageNavigationForColorsonic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__